"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var skynet_store_properties_api_1 = require("@synisys/skynet-store-properties-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var timer_1 = require("rxjs/observable/timer");
var operators_1 = require("rxjs/operators");
var async_1 = require("rxjs/scheduler/async");
var abstract_destruction_subject_1 = require("../abstract-destruction-subject");
require("./header-comment-button.component.scss");
var HeaderCommentButtonComponent = /** @class */ (function (_super) {
    __extends(HeaderCommentButtonComponent, _super);
    function HeaderCommentButtonComponent(store, authorization, authentication, httpClient, ngZone) {
        var _this = _super.call(this) || this;
        _this.store = store;
        _this.authorization = authorization;
        _this.authentication = authentication;
        _this.httpClient = httpClient;
        _this.ngZone = ngZone;
        return _this;
    }
    HeaderCommentButtonComponent_1 = HeaderCommentButtonComponent;
    HeaderCommentButtonComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.entity) {
            // TODO(comments-store-integration): temporary
            this.commentsCount$ = skynet_store_properties_api_1.getProperties(this.store).pipe(operators_1.switchMap(function (props) {
                return timer_1.timer(0, 10000, skynet_store_utilities_1.leaveZone(_this.ngZone, async_1.async)).pipe(operators_1.switchMap(function () {
                    return _this.httpClient.get(props['comment-service-url'] + "/comment/count", {
                        params: {
                            resourceId: _this.categoryName + "_" + _this.entity.getInstanceId(),
                            resourceTypeId: '1',
                        },
                    });
                }));
            }), operators_1.filter(function (x) { return x !== 0; }), operators_1.startWith(undefined), operators_1.observeOn(skynet_store_utilities_1.enterZone(this.ngZone, async_1.async)), operators_1.takeUntil(this.destroySubject$));
            this.hasPermission = this.authentication.getUserData().pipe(operators_1.first(), operators_1.map(function (userData) { return userData.userId; }), operators_1.switchMap(function (userId) {
                return _this.authorization.getPermissionAccessValue(userId, HeaderCommentButtonComponent_1.COMMENT_VIEW_PERMISSION_KEY);
            }), operators_1.map(function (permissionValueDto) {
                return permissionValueDto.access === idm_authorization_client_js_1.Access.FULL;
            }), operators_1.first());
        }
    };
    HeaderCommentButtonComponent.prototype.openComments = function () {
        if (this.formActions && this.formActions.openComments) {
            this.formActions.openComments();
        }
    };
    HeaderCommentButtonComponent.COMMENT_VIEW_PERMISSION_KEY = 'b1349856-5d6d-11eb-ae93-0242ac130002';
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], HeaderCommentButtonComponent.prototype, "formActions", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_core_frontend_1.Entity)
    ], HeaderCommentButtonComponent.prototype, "entity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], HeaderCommentButtonComponent.prototype, "categoryName", void 0);
    HeaderCommentButtonComponent = HeaderCommentButtonComponent_1 = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'header-comment-button',
            template: require('./header-comment-button.component.html'),
        }),
        __metadata("design:paramtypes", [store_1.Store,
            idm_authorization_client_js_1.AuthorizationService,
            idm_authentication_client_js_1.AuthenticationService,
            http_1.HttpClient,
            core_1.NgZone])
    ], HeaderCommentButtonComponent);
    return HeaderCommentButtonComponent;
    var HeaderCommentButtonComponent_1;
}(abstract_destruction_subject_1.AbstractDestructionSubject));
exports.HeaderCommentButtonComponent = HeaderCommentButtonComponent;
//# sourceMappingURL=header-comment-button.component.js.map